import request from '@/utils/http';
import { PFX,SRM, SRM_FILE, SRM_FILE_PRE } from '../../constant/constant.js';


// 仓库人员列表导出
export const workerExport = data => {
    return request({
        url: `${SRM_FILE}/warehouseWorker/export`,
        method: 'post',
        data
    });
};

// 仓库人员列表
export const workerPage = data => {
    return request({
        url: `${SRM}/warehouseWorker/workerPage`,
        method: 'post',
        data
    });
};

// 更新服务平台
export const supplierWarehouseDelegateRefresh = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/reFresh`,
        method: 'post',
        data
    });
};
// 仓库人员所属合同
export const workerContractPage = data => {
    return request({
        url: `${SRM}/warehouseWorker/contractPage`,
        method: 'post',
        data
    });
};

// 审批人配置列表
export const warehouseDelegateProcessConfig = data => {
    return request({
        url: `${SRM}/warehouseDelegateProcessConfig/page`,
        method: 'post',
        data
    });
};

// 审批人配置保存
export const warehouseDelegateProcessConfigSave = data => {
    return request({
        url: `${SRM}/warehouseDelegateProcessConfig/save`,
        method: 'post',
        data
    });
};

// 审批人配置编辑
export const warehouseDelegateProcessConfigUpdate = data => {
    return request({
        url: `${SRM}/warehouseDelegateProcessConfig/update`,
        method: 'post',
        data
    });
};

// 服务平台带出线下委派函
export const businessCenterManager = data => {
    return request({
        url: `${PFX}/contract/contractWarningMipInfo/businessCenterManager`,
        method: 'get',
        params: data
    });
};

// 审批人配置删除
export const warehouseDelegateProcessConfigDel = id => {
    return request({
        url: `${SRM}/warehouseDelegateProcessConfig/delete/${id}`,
        method: 'get',
        // data
    });
};
// lsrm 分页查询
export const manageSearch = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/manageSearch`,
        method: 'post',
        data
    });
};
// lsp 分页查询
export const supplierWarehouseDelegateSearh = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/search`,
        method: 'post',
        data
    });
};

// 签署详情列表页
export const recordPage = data => {
    return request({
        url: `${SRM}/warehouseDelegateSignRecord/recordPage`,
        method: 'post',
        data
    });
};

// 启用
export const postEnable = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/enable`,
        method: 'post',
        data
    });
};

// 停用
export const postDisable = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/disable`,
        method: 'post',
        data
    });
};

// 委派函管理-发起供应商签署
export const commissioning = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/commissioning`,
        method: 'post',
        data
    });
};

// 委派函管理-审批记录
export const mipAuditPage = data => {
    return request({
        url: `${SRM}/warehouseDelegateMipAudit/mipAuditPage`,
        method: 'post',
        data
    });
};

// 委派函管理-操作记录
export const supplierWarehouseDelegateOperateRecord = data => {
    return request({
        url: `${PFX}/supplierWarehouseDelegateOperateRecord/page`,
        method: 'post',
        data
    });
};


// lsrm导出
export const lsrmExportWarehouseDelegate = data => {
    return request({
        url: `${SRM_FILE_PRE}/supplier/warehouseDelegate/lsrmExportWarehouseDelegate`,
        method: 'post',
        data
    });
};

// lsp导出
export const lspExportWarehouseDelegate = data => {
    return request({
        url: `${SRM_FILE_PRE}/supplier/warehouseDelegate/lspExportWarehouseDelegate`,
        method: 'post',
        data
    });
};

// 校验修改信息
export const checkChange = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/checkChange`,
        method: 'post',
        data
    });
};

// 提交审批
export const submitApprove = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/submitApprove`,
        method: 'post',
        data
    });
};

// 委派函详情
export const getDelegateDetail = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/detail/${data}`,
        method: 'get',
    });
};

// 审批详情
export const getApprovalDetail = data => {
    return request({
        url: `${SRM}/warehouseDelegateMipAudit/approvalDetail/${data}`,
        method: 'get',
    });
};

// 线下委派函模板下载
export const downloadTemplate = data => {
    return request({
        url: `${SRM_FILE_PRE}/supplier/warehouseDelegate/downloadTemplate`,
        method: 'get',
    });
};

// 审批
export const approvalDelegate = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/approval`,
        method: 'post',
        data,
    });
};

// 审批可选项
export const getOperation = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/operation/${data}`,
        method: 'get',
    });
};

// 重推委派函
export const getRePush = id => {
    return request({
        url: `${SRM}/warehouseDelegateSignRecord/rePush/${id}`,
        method: 'get',
    });
};

// 装卸人员分页查询
export const getWorkerPage = data => {
    return request({
        url: `${SRM}/warehouseWorker/workerPage`,
        method: 'post',
        data,
    });
};

// 根据法务合同号 + 委派函类型，获取审批人接口
export const queryApprove = data => {
    return request({
        url: `${SRM}/warehouseDelegateProcessConfig/queryApprove`,
        method: 'post',
        data,
    });
};

// 仓储委派函保存
export const supplierWarehouseDelegateSave = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/save`,
        method: 'post',
        data,
    });
};

// 仓储委派函删除
export const supplierWarehouseDelegateDel = id => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/delete/${id}`,
        method: 'get',
    });
};

// 仓储委派函批量审批
export const batchApproval = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/batchApproval`,
        method: 'post',
        data
    });
};

// 修改合同号保存
export const batchChangeContractSave = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/batchChangeContractSave`,
        method: 'post',
        data
    });
};

// 修改合同号提交
export const batchChangeContractSubmit = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/batchChangeContractSubmit`,
        method: 'post',
        data
    });
};

// 根据委派函编码获取委派函数据
export const changeMainLogicalWarehouse = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/changeMainLogicalWarehouse`,
        method: 'post',
        data,
    });
};

// 获取发薪日期配置
export const queryPaydayConfig = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryPaydayConfigDetail/queryPaydayConfig`,
        method: 'post',
        data,
    });
};

// 发薪日期校验
export const checkSalaryPayday = data => {
    return request({
        url: `${SRM}/supplierWarehouseDelegate/checkSalaryPayday`,
        method: 'post',
        data,
    });
};
